import { declaratives } from './light/declaratives.js';

const lightTheme = declaratives;
/**
 * @deprecated arcadiaLate2021Theme has been renamed lightTheme
 */
const arcadiaLate2021Theme = declaratives;

export { arcadiaLate2021Theme, lightTheme };
